import React, { useState } from "react";
import { Modal } from "bootstrap";
import Gallery1 from "../assets/gallery/0.jpeg";
import Gallery2 from "../assets/gallery/1.jpg";
import Gallery3 from "../assets/gallery/2.jpg";
import Gallery4 from "../assets/gallery/3.jpg";
import Gallery5 from "../assets/gallery/4.jpg";
import Gallery6 from "../assets/gallery/5.jpg";
import Gallery7 from "../assets/gallery/6.jpg";
import Gallery8 from "../assets/gallery/7.jpg";

import gal1im1 from "../assets/gallery/Aranthangi Warehouse Photo Copy/1-min.jpeg";
import gal1im2 from "../assets/gallery/Aranthangi Warehouse Photo Copy/2-min.jpeg";
import gal1im3 from "../assets/gallery/Aranthangi Warehouse Photo Copy/3-min.jpeg";
import gal1im4 from "../assets/gallery/Aranthangi Warehouse Photo Copy/4-min.jpeg";
import gal1im5 from "../assets/gallery/Aranthangi Warehouse Photo Copy/6-min.jpeg";
import gal1im6 from "../assets/gallery/Aranthangi Warehouse Photo Copy/9-min.jpeg";

import gal2im1 from "../assets/gallery/KarurWarehouse/1.JPG";
import gal2im2 from "../assets/gallery/KarurWarehouse/2.JPG";
import gal2im3 from "../assets/gallery/KarurWarehouse/3.JPG";
import gal2im4 from "../assets/gallery/KarurWarehouse/4.JPG";
import gal2im5 from "../assets/gallery/KarurWarehouse/5.JPG";
import gal2im6 from "../assets/gallery/KarurWarehouse/6.JPG";
import gal2im7 from "../assets/gallery/KarurWarehouse/7.JPG";
import gal2im8 from "../assets/gallery/KarurWarehouse/8.JPG";
import gal2im9 from "../assets/gallery/KarurWarehouse/9.JPG";
import gal2im10 from "../assets/gallery/KarurWarehouse/10.JPG";
import gal2im11 from "../assets/gallery/KarurWarehouse/11.JPG";
import gal2im12 from "../assets/gallery/KarurWarehouse/12.JPG";
import gal2im13 from "../assets/gallery/KarurWarehouse/13.JPG";
import gal2im14 from "../assets/gallery/KarurWarehouse/14.JPG";
import gal2im15 from "../assets/gallery/KarurWarehouse/15.JPG";

function Gallery() {
  const galleryData = [
    {
      id: 1,
      tag: "Aranthangi Warehouse",
      images: [
        gal1im1,
        gal1im2,
        gal1im3,
        gal1im4,
        gal1im5,
        gal1im6,
      ],
    },
    {
      id: 2,
      tag: "Karur Warehouse",
      images: [
        gal2im1,
        gal2im2,
        gal2im3,
        gal2im4,
        gal2im5,
        gal2im6,
        gal2im7,
        gal2im8,
        gal2im9,
        gal2im10,
        gal2im11,
        gal2im12,
        gal2im13,
        gal2im14,
        gal2im15
      ],
    },
    {
      id: 3,
      tag: "Workshop",
      images: [
        Gallery6,
        Gallery5,
        Gallery2,
      ],
    },
  ];

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const openModal = (category) => {
    setSelectedCategory(category);
    setSelectedIndex(0);

    const modal = new Modal(document.getElementById("galleryModal"));
    modal.show();
  };

  const handleNext = () => {
    if (!selectedCategory) return;

    setSelectedIndex((prev) =>
      prev === selectedCategory.images.length - 1 ? 0 : prev + 1
    );
  };

  const handlePrev = () => {
    if (!selectedCategory) return;

    setSelectedIndex((prev) =>
      prev === 0 ? selectedCategory.images.length - 1 : prev - 1
    );
  };

  return (
    <div className="container my-5">
      <h3 className="text-center fw-bold mb-4">Gallery</h3>

      {/* ✅ Category Grid */}
      <div className="row g-4">
        {galleryData.map((category) => (
          <div key={category.id} className="col-6 col-md-4">
            <div
              className="card shadow-sm border-0 overflow-hidden h-100"
              style={{ cursor: "pointer" }}
              onClick={() => openModal(category)}
            >
              <img
                src={category.images[0]}
                alt={category.tag}
                className="w-100"
                style={{
                  height: "220px",
                  objectFit: "cover"
                }}
              />

              <div className="card-body text-center">
                <h6 className="fw-semibold mb-0">{category.tag}</h6>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ Modal */}
      <div className="modal fade" id="galleryModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content bg-dark border-0">
            <div className="modal-body position-relative text-center">

              {selectedCategory && (
                <div className="d-flex justify-content-center align-items-start gap-3">

                  {/* Fixed Size Preview Container */}
                  <div
                    className="position-relative d-flex align-items-center justify-content-center bg-black rounded"
                    style={{
                      width: "600px",
                      height: "500px",
                      overflow: "hidden",
                    }}
                  >
                    {/* Main Preview Image */}
                    <img
                      src={selectedCategory.images[selectedIndex]}
                      alt="preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />

                    {/* Left Button */}
                    <button
                      className="btn btn-light position-absolute top-50 start-0 translate-middle-y"
                      onClick={handlePrev}
                    >
                      ❮
                    </button>

                    {/* Right Button */}
                    <button
                      className="btn btn-light position-absolute top-50 end-0 translate-middle-y"
                      onClick={handleNext}
                    >
                      ❯
                    </button>
                  </div>

                  {/* Thumbnails Column */}
                  <div
                    className="d-flex flex-column gap-2 overflow-auto"
                    style={{ maxHeight: "500px" }}
                  >
                    {selectedCategory.images.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`thumb-${index}`}
                        onClick={() => setSelectedIndex(index)}
                        className={`rounded ${selectedIndex === index ? "border border-3 border-light" : ""
                          }`}
                        style={{
                          width: "90px",
                          height: "70px",
                          objectFit: "cover",
                          cursor: "pointer",
                          opacity: selectedIndex === index ? 1 : 0.6,
                        }}
                      />
                    ))}
                  </div>

                </div>
              )}

            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Gallery